import React from 'react';
import PropTypes from 'prop-types';
import SubmitButton from 'components/global/Buttons/SubmitButton';
import { useAssessmentContext } from 'services/context/assessmentContext/useAssessmentContext';
import { FlexContainer } from 'components/local/styles/StyledComponents';
import {
  NavWrapper,
  QuestionCount
} from 'components/local/navbar/styles/StyledComponents';
import { getSubmitButtonText } from 'containers/app/helpers/getSubmitButtonText';
import { shouldSubmitAssessment } from 'containers/app/helpers/shouldSubmitAssessment';
import { QuestionTypes } from 'containers/app/helpers/questionTypes';
import { useTranslation } from 'react-i18next';

const LinearBottomNavBar = ({
  background,
  flat,
  formikProps,
  minimal,
  setShowSummary
}) => {
  const { t } = useTranslation();
  const { state, currentSection, currentSlot } = useAssessmentContext();
  const { currentSlotIndex, assessmentAttempt, files } = state;
  const {
    assessment: { sections: totalSections }
  } = assessmentAttempt;
  const slotNumber = currentSlotIndex + 1;
  const sectionLength = currentSection.slot_attempts.length;

  const isAssessmentReadyToSubmit = shouldSubmitAssessment(
    totalSections.length,
    currentSection.sort_index,
    sectionLength,
    currentSlotIndex
  );

  const isVideoQuestion =
    currentSlot?.question?.question_type === QuestionTypes.UPLOAD &&
    currentSlot?.question?.accept_types?.includes('video');
  const isFileQuestion =
    currentSlot?.question?.question_type === QuestionTypes.UPLOAD &&
    currentSlot?.question?.accept_types === null;

  return (
    <NavWrapper background={background} flat={flat} height="72px">
      <FlexContainer
        width="100%"
        justifyContent="flex-end"
        alignItems="center"
        maxWidth="1024px"
      >
        {!minimal && (
          <QuestionCount>
            {t('questionProgress.ofTotal', {
              current: slotNumber,
              total: sectionLength
            })}
          </QuestionCount>
        )}
        <SubmitButton
          formikProps={formikProps}
          text={
            slotNumber === sectionLength
              ? getSubmitButtonText(!isAssessmentReadyToSubmit, true)
              : t('buttons.next')
          }
          setShowSummary={setShowSummary}
          disabled={
            // For video questions, the object key is the id
            (isVideoQuestion && !files[currentSlot?.id]) ||
            // For file questions, the object key is the file name
            (isFileQuestion && Object.keys(files).length === 0)
          }
        />
      </FlexContainer>
    </NavWrapper>
  );
};

LinearBottomNavBar.propTypes = {
  background: PropTypes.string,
  flat: PropTypes.bool,
  formikProps: PropTypes.object.isRequired,
  minimal: PropTypes.bool,
  setShowSummary: PropTypes.func
};

LinearBottomNavBar.defaultProps = {
  background: '#ffffff',
  flat: false,
  minimal: false,
  setShowSummary: null
};

export default LinearBottomNavBar;
